import {
  nextFriday,
  nextMonday,
  nextSaturday,
  nextSunday,
  nextThursday,
  nextTuesday,
  nextWednesday,
} from 'date-fns';
import { DayOfWeek } from '@iss/libs/graphql';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe, DatePipeConfig } from '@angular/common';

@Pipe({ name: 'recurrenceDayOfWeek', pure: false, standalone: true })
export class RecurrenceDayOfWeekPipe implements PipeTransform {
  private static readonly map = {
    [DayOfWeek.Monday]: nextMonday,
    [DayOfWeek.Tuesday]: nextTuesday,
    [DayOfWeek.Wednesday]: nextWednesday,
    [DayOfWeek.Thursday]: nextThursday,
    [DayOfWeek.Friday]: nextFriday,
    [DayOfWeek.Saturday]: nextSaturday,
    [DayOfWeek.Sunday]: nextSunday,
  };
  private readonly datePipe: DatePipe;

  public constructor(
  @Inject(LOCALE_ID) localeId: string,
    @Inject(DATE_PIPE_DEFAULT_OPTIONS) defaultOptions: DatePipeConfig,
  ) {
    this.datePipe = new DatePipe(localeId, undefined, defaultOptions);
  }

  public transform(value: DayOfWeek | null | undefined, abbr = true): string | null {
    const nextWeekday = value ? RecurrenceDayOfWeekPipe.map[value] : null;
    return nextWeekday
      ? this.datePipe.transform(nextWeekday(new Date()), abbr ? 'EEE' : 'EEEE')
      : null;
  }
}
